module.exports = __webpack_public_path__ + "static/sample-12-c5da7142ffaa1a430e35580768fe0fed.png";